var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFooterYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3572 4.05221C22.3888 4.32973 23.2014 5.14758 23.4771 6.18586C23.9782 8.06802 23.9782 11.9947 23.9782 11.9947C23.9782 11.9947 23.9782 15.9216 23.4771 17.8036C23.2014 18.842 22.3888 19.6597 21.3572 19.9374C19.4873 20.4416 11.9891 20.4416 11.9891 20.4416C11.9891 20.4416 4.49088 20.4416 2.62085 19.9374C1.58924 19.6597 0.776704 18.842 0.500954 17.8036C0 15.9216 0 11.9947 0 11.9947C0 11.9947 0 8.06802 0.500954 6.18586C0.776704 5.14758 1.58924 4.32973 2.62085 4.05221C4.49088 3.54785 11.9891 3.54785 11.9891 3.54785C11.9891 3.54785 19.4873 3.54785 21.3572 4.05221ZM9.53613 8.42944V15.5598L15.8032 11.9947L9.53613 8.42944Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFooterYoutube);
export default __webpack_public_path__ + "static/media/icon-footer-youtube.4e9e872d972f83d50797809e69251791.svg";
export { ForwardRef as ReactComponent };